import React from "react";
import "./card.css";

const Card = ({ cardImg, heading, bgColor, children }) => {
  return (
    <div className="nftCard-main-wrapper" style={{ background: bgColor, marginLeft: '10px', marginRight: '10px' }}>
      <div className="nftCard-inner-wrapper">
        <img src={cardImg} alt="cardImg" />
        <h3>{heading}</h3>
        {children}
      </div>
    </div>
  );
};

export default Card;
